import React, {useContext, useMemo} from 'react';
import {AuditMarkingContext} from '../context';
import WaterFall from './components/WaterFall/index';
import * as actiontypes from '../reducer/action';
import {Modal, Button} from 'antd';
import WaterFallTitle from './components/WaterFallTitle';
import TagListManager from './components/TagListManager';
import './index.less';

// 模态框头部
const Title = (props) => {
	const {state, dispatch, queryData} = useContext(AuditMarkingContext);
	return (
		<div className='auditMarkingModalTitle'>
			<Button
				type='default'
				onClick={() => {
					dispatch({
						type: actiontypes.setData,
						data: {
							insGroup: [],
							visible: false,
							checkedAll: false,
						},
					});
					queryData(state.page, 10);
				}}
			>
				&lt; 返回列表
			</Button>
			<h1>{state.modalTitle}</h1>
			<span>{state.current <= 1 ? '不通过' : '评星数'}: {state.modalRightCount}</span>
		</div>
	);
};

function FunctionModal(props) {
	const {state, dispatch, queryData} = useContext(AuditMarkingContext);
	const onChange = (index, tag, starCount) => {
		if (tag === 'choose') {
			if (!state.insGroup[index].delete) {
				state.insGroup[index].checked = !state.insGroup[index].checked;
				dispatch({
					type: actiontypes.setData,
					data: {
						insGroup: [...state.insGroup],
					},
				});
			}
		} else if (tag === 'delete') {
			if (!state.insGroup[index].delete) {
				state.insGroup[index].delete = !state.insGroup[index].delete;
				dispatch({
					type: actiontypes.setData,
					data: {
						insGroup: [...state.insGroup],
					},
				});
				dispatch({
					type: actiontypes.modalRightCountIncrease,
				});
			}
		} else if (tag === 'pop') {
			if (!state.insGroup[index].delete) {
				state.insGroup[index].visible = true;
				dispatch({
					type: actiontypes.setData,
					data: {
						insGroup: [...state.insGroup],
					},
				});
			}
		} else if (tag === 'hide') {
			if (!state.insGroup[index].delete) {
				state.insGroup[index].visible = false;
				dispatch({
					type: actiontypes.setData,
					data: {
						insGroup: [...state.insGroup],
					},
				});
			}
		} else if (tag === 'star') {
			if (!state.insGroup[index].delete) {
				state.insGroup[index].star = starCount;
				dispatch({
					type: actiontypes.setData,
					data: {
						insGroup: [...state.insGroup],
					},
				});
			}
		} else if (tag === "showBigImg") {
			if (!state.insGroup[index].delete) {
				state.insGroup[index].showBigImg = true;
				dispatch({
					type: actiontypes.setData,
					data: {
						insGroup: [...state.insGroup],
					},
				});
			}
		} else if (tag === "hideBigImg") {
			if (!state.insGroup[index].delete) {
				state.insGroup[index].showBigImg = false;
				dispatch({
					type: actiontypes.setData,
					data: {
						insGroup: [...state.insGroup],
					},
				});
			}
		}
	};

	return useMemo(() => {
		return (
			<Modal
				visible={state.visible}
				onCancel={() => {
					dispatch({
						type: actiontypes.setData,
						data: {
							visible: false,
							insGroup: [],
							handleTagVisible: false,
							passAllButtonLoading: false,
							checkedAll: false,
						},
					});
					queryData(state.page, 10);
				}}
				title={<Title/>}
				footer={null}
				width={1660}
				destroyOnClose={true}
				maskClosable={false}
			>
				<WaterFallTitle/>
				<WaterFall
					// list={state.insGroup.filter((v) => !v.tags)}
					containerWidth={1600}
					itemWidth={246}
					columnCount={6}
					onChange={onChange}
					// needResize={state.virtualWaterUpdate}
					type={2}
				/>
				{state.handleTagVisible ? <TagListManager/> : null}
			</Modal>
		);
	}, [state]);
}

export default FunctionModal;
